import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { putApi } from "../services/apis";
import { asyncInittalState, AsyncState, handleAsync } from "./sharedSliceUtils";
import { toast } from 'react-toastify';
import { fetchData } from "./invoiceData.slice";

type CountsState = AsyncState & {
    total: number,
    overdue: number,
    needsReview: number,
}

const initialState: CountsState = {
    total: 0,
    overdue: 0,
    needsReview: 0,
    ...asyncInittalState,
}

export const sendEmail = createAsyncThunk('send/Email', async (trackingId: string) => {
    const response = await putApi(`/api/ArDashboard/SetEmailSentStatus/${trackingId}`, { status: 1 });
    return response.data;
});

export const countSlice = createSlice({
    name: 'counts',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchData.pending, handleAsync.pending)
            .addCase(fetchData.fulfilled, (state, action: PayloadAction<{ countByCategory: { total: number; overdue: number; needsReview: number } }>) => {
                state.loading = false;
                state.total = action.payload.countByCategory.total;
                state.overdue = action.payload.countByCategory.overdue;
                state.needsReview = action.payload.countByCategory.needsReview;
            })
            .addCase(fetchData.rejected, handleAsync.rejected)
            .addCase(sendEmail.pending, handleAsync.pending)
            .addCase(sendEmail.fulfilled, () => {
                handleAsync.fulFilled;
                toast.success('Mark email as sent!');
            })
            .addCase(sendEmail.rejected, () => {
                handleAsync.rejected;
                toast.error('Failed to send email');
            })
    },
});

export default countSlice.reducer;